import React, { useEffect, useState } from 'react';
import './preview-manager-landing.styles.scss';

import { previewGameData, previewGameMessages, previewUserContent } from '../previewGameData';
import { previewPendingActionItems } from '../previewGameActionItems';
import { gameActivityLast30 } from '../previewGameActivity';
import { gameElementsShortList } from '../previewGameElements';
import { playerDocs } from '../previewPlayers';
import { previewGameStats } from '../previewGameData';
import { previewTeamMembers } from '../previewPlayers';
import { previewPasscodes } from '../previewPlayers';

import { Desktop, LargeTablet, Mobile, Tablet } from '@/utils/responsiveQueries';
import ManageHeadBar from '@/components/MANAGE-GAME/manage-layout/manage-game-head-bar/manage-head-bar.component';
import ManageGameSidebar from '@/components/MANAGE-GAME/manage-layout/manage-game-sidebar/manage-game-sidebar.component';
import ManageLanding from '@/components/MANAGE-GAME/manage-landing.component';
import ManageMobileHeader from '@/components/MANAGE-GAME/manage-layout/manage-game-head-bar/manage-mobile-head.component';
import Loader from '@/components/loader/loader.comp';
import PreviewBorder from '../preview-border/preview-border.component';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentUser, setMembership, setUserProfile } from '@/state/slices/userSlice';
import { useNavigate } from 'react-router-dom';
import { ModalAlert } from '@/components/modal/modal.component';
import GameInfoModal from '@/components/SHARED/game-info-modal/game-info-modal.component';

const PreviewManagerLanding = () => {

  const currentUser = useSelector(state => state.userData.currentUser);
  const [currentGame, setCurrentGame] = useState(previewGameData);
  const [actionItems, setActionItems] = useState(previewPendingActionItems);
  const [gameElements, setGameElements] = useState(gameElementsShortList);
  const [playerList, setPlayerList] = useState(playerDocs);
  const [orgs, setOrgs] = useState({});
  const [role, setRole] = useState('manager');
  const [defaultActivityRecords, setDefaultActivityRecords] = useState(gameActivityLast30);
  const [gameStats, setGameStats] = useState(previewGameStats);
  const [teamMembers, setTeamMembers] = useState(previewTeamMembers);
  const [passcodes, setPasscodes] = useState(previewPasscodes);
  const [gameMessages] = useState(previewGameMessages);
  const [gameManagers, setGameManagers] = useState([]);
  const [activityCounts, setActivityCounts] = useState({});
  const [alertMessage, setAlertMessage] = useState(null);
  const [ showGameInfoModal, setShowGameInfoModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      localStorage.removeItem(`seenIntroVideo`);
    };
  }, []);

  useEffect(() => {
    if (!currentUser) return;
    if (currentUser.uid !== "preview-manager") {
      navigate('/logout?redirectUrl=/preview/manager/previewgame');
    }
  }, [currentUser])

  useEffect(() => {
    if (!currentGame) return;
    document.title = `Gamably Preview Game Manager`;
    const r = document.querySelector(':root');
    r.style.setProperty('--primary', currentGame.color);
    r.style.setProperty('--primary-trans', currentGame.color + 'a6');
  }, [currentGame]);

  useEffect(() => {
    if (!previewUserContent) {
      dispatch(setCurrentUser({}));
      dispatch(setMembership({}));
      dispatch(setUserProfile({}));
      return;
    } else {
      dispatch(setCurrentUser(previewUserContent.currentUser));
      dispatch(setMembership(previewUserContent.membership));
      dispatch(setUserProfile(previewUserContent.userProfile));
      createActivityCounts();
    }
  }, [previewUserContent]);

  function changeActionItemStatus() {
    setAlertMessage('Sorry! Data cannot be changed in Preview Mode.');
    return;
  }

  function createActivityCounts() {
    const counts = {};
    // create for the last 10 days for demo purposes
    // schema:
    // "daily-2024-08-01": {
    //   "count": 100,
    //   "date": "2024-08-01",
    //   "expiresAt": [10 days later]
    // }
    for (let i = 0; i <= 10; i++) {
      const date = new Date();
      date.setDate(date.getDate() - i);
      const dateString = date.toISOString().split('T')[0];
      counts[`daily-${dateString}`] = {
        count: Math.floor(Math.random() * 100),
        date: dateString,
        expiresAt: new Date(date.getTime() + 10 * 24 * 60 * 60 * 1000).getTime()
      }
    }
    setActivityCounts(counts);

  }

  return (
    <div className='preview-manager-landing'>

      {
        (currentGame)
          ?
          <div className='manage-game-page' style={
            (currentGame.bg.type === 'gradient')
              ?
              { 'background': `linear-gradient(to bottom, ${currentGame.bg.hexTop}, ${currentGame.bg.hexBottom})` }
              :
              { 'backgroundImage': `url("${currentGame.bg.url}")` }
          }>
            <Desktop>
              <ManageHeadBar gameData={currentGame} />
              <div className='manage-content'>
                <ManageGameSidebar
                  gameData={currentGame}
                  actionItems={actionItems}
                  gameElements={gameElements}
                  playerList={playerList}
                  setShowGameInfoModal={setShowGameInfoModal}
                  orgs={orgs}
                  role={role}
                />
                <ManageLanding
                  gameData={currentGame}
                  gameElements={gameElements}
                  playerList={playerList}
                  defaultActivityRecords={defaultActivityRecords}
                  gameStats={gameStats}
                  actionItems={actionItems}
                  changeActionItemStatus={changeActionItemStatus}
                  teamMembers={teamMembers}
                  passcodes={passcodes}
                  gameMessages={gameMessages}
                  gameManagers={gameManagers}
                  activityCounts={activityCounts}
                  orgs={orgs}
                  role={role}
                />
              </div>
            </Desktop>

            <LargeTablet>
              <ManageMobileHeader
                gameData={currentGame}
                gameElements={gameElements}
                playerList={playerList}
                actionItems={actionItems}
                setShowGameInfoModal={setShowGameInfoModal}
                orgs={orgs}
                role={role} />
              {/* <div className='manage-content'> */}
              {/* <ManageGameSidebar 
                            gameData={currentGame} 
                            actionItems={actionItems} 
                            gameElements={gameElements}
                            orgs={orgs}
                            role={role}
                        /> */}
              <ManageLanding
                gameData={currentGame}
                gameElements={gameElements}
                playerList={playerList}
                defaultActivityRecords={defaultActivityRecords}
                gameStats={gameStats}
                actionItems={actionItems}
                changeActionItemStatus={changeActionItemStatus}
                teamMembers={teamMembers}
                passcodes={passcodes}
                gameMessages={gameMessages}
                gameManagers={gameManagers}
                activityCounts={activityCounts}
                orgs={orgs}
                role={role}
              />
              {/* </div> */}
            </LargeTablet>

            <Tablet>
              <ManageMobileHeader
                gameData={currentGame}
                gameElements={gameElements}
                playerList={playerList}
                actionItems={actionItems}
                setShowGameInfoModal={setShowGameInfoModal}
                orgs={orgs}
                role={role} />
              <ManageLanding
                gameData={currentGame}
                gameElements={gameElements}
                playerList={playerList}
                defaultActivityRecords={defaultActivityRecords}
                gameStats={gameStats}
                actionItems={actionItems}
                changeActionItemStatus={changeActionItemStatus}
                teamMembers={teamMembers}
                passcodes={passcodes}
                gameMessages={gameMessages}
                gameManagers={gameManagers}
                activityCounts={activityCounts}
                orgs={orgs}
                role={role} />
            </Tablet>

            <Mobile>
              <ManageMobileHeader
                gameData={currentGame}
                gameElements={gameElements}
                actionItems={actionItems}
                playerList={playerList}
                setShowGameInfoModal={setShowGameInfoModal}
                orgs={orgs}
                role={role} />
              <ManageLanding
                gameData={currentGame}
                gameElements={gameElements}
                playerList={playerList}
                defaultActivityRecords={defaultActivityRecords}
                gameStats={gameStats}
                actionItems={actionItems}
                changeActionItemStatus={changeActionItemStatus}
                teamMembers={teamMembers}
                passcodes={passcodes}
                gameMessages={gameMessages}
                gameManagers={gameManagers}
                activityCounts={activityCounts}
                orgs={orgs}
                role={role} />
            </Mobile>
          </div>
          :
          <div className='loading-page'>
            <Loader />
          </div>
      }
      {
        (currentGame) &&
        <GameInfoModal
          showGameInfoModal={showGameInfoModal}
          setShowGameInfoModal={setShowGameInfoModal}
          currentGame={currentGame} />
      }
      <ModalAlert
        show={!!alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
      <PreviewBorder />
    </div>
  )
}

export default PreviewManagerLanding